const bjpCandidates: string[] = [
  'Number one candidate name',
  `No. 2 candidate's name`,
  'Name of the number three candidate',
]

export default bjpCandidates
